var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.679,
    height: 17.601,
    viewBox: "0 0 23.679 17.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.661 -11.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.161 13.321)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,18H20.858",
    transform: "translate(-7.5 -11.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,7.5l6.679,6.679L18,20.858",
    transform: "translate(-11.321 -7.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H13.358",
    transform: "translate(20.679) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesArrow);
export default __webpack_public_path__ + "static/media/resources_arrow.b0da7ce04abb8a5442d8de9627c31073.svg";
export { ForwardRef as ReactComponent };